import {
  FETCH_WITHDRAWS,
  FETCH_WITHDRAWS_SUCCESS,
  FETCH_WITHDRAWS_FAILED,
  EDIT_WITHDRAWS
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue } from "firebase/database";
import { httpsCallable } from "firebase/functions";

export const fetchWithdraws = () => (dispatch) => {

  const {
    withdrawRef
  } = firebase;

  dispatch({
    type: FETCH_WITHDRAWS,
    payload: null
  });
 onValue(withdrawRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i
        return data[i]
      });
      dispatch({
        type: FETCH_WITHDRAWS_SUCCESS,
        payload: arr.reverse()
      });
    } else {
      dispatch({
        type: FETCH_WITHDRAWS_FAILED,
        payload: "No WITHDRAWS available."
      });
    }
  });
};

export const updateWithdrawalStatus = (entry, status, metadata = {}) => async (dispatch) => {
  dispatch({
    type: EDIT_WITHDRAWS,
    payload: entry
  });
  const updateStatus = httpsCallable(firebase.functions, 'updateWithdrawalStatus');
  const response = await updateStatus({
    requestId: entry.id,
    status,
    ...metadata,
  });
  return response.data;
}

export const completeWithdraw = (entry, payoutReference) => (dispatch) =>
  dispatch(updateWithdrawalStatus(entry, 'paid', { payoutReference }));
